import { render } from "./Producto.vue?vue&type=template&id=7f5ff274&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"

import "./Producto.vue?vue&type=style&index=0&id=7f5ff274&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5ff274"]])

export default __exports__